/**
 * 自定义Size选择器 - AlpineJS 实现
 * 处理Size选择器的交互逻辑和与原始变体选择器的同步
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('customSizeSelector', () => ({
        // 状态
        selectedSize: '',
        unit: 'inches', // 'inches' 或 'cm'
        popupUnit: 'inches', // 弹窗内的单位
        popupMobileUnit: 'inches', // 移动端弹窗内的单位
        deliveryDateRange: 'Counting...',
        productForm: null,
        optionPosition: null,

        // 初始化
        init() {
            this.optionPosition = this.$root.dataset.optionPosition;
            this.productForm = this.findProductForm();

            // 同步原始选择器状态
            this.$nextTick(() => {
                this.syncWithOriginalSelector();
                this.calculateDeliveryDate();
            });
        },

        // 查找产品表单
        findProductForm() {
            // 首先尝试向上查找产品表单
            let element = this.$root;
            while (element && !element.matches('form[action*="/cart/add"]')) {
                element = element.parentElement;
            }

            if (element) return element;

            // 如果向上查找失败，尝试在页面中查找产品表单
            const productForm = document.querySelector('form[action*="/cart/add"]');
            if (productForm) return productForm;

            // 如果还是找不到，尝试查找包含特定类的表单
            const shopifyForm = document.querySelector('form.shopify-product-form');
            if (shopifyForm) return shopifyForm;

            console.warn('Custom size selector: Product form not found');
            return null;
        },

        // 同步原始选择器状态
        syncWithOriginalSelector() {
            if (!this.productForm) return;

            // 查找当前选中的尺寸选项
            const inputs = this.$root.querySelectorAll('.custom-size-option__input');
            let foundMatch = false;

            // 首先检查是否有 checked 的 radio button
            inputs.forEach((input) => {
                if (input.checked) {
                    this.selectedSize = input.value;
                    foundMatch = true;
                }
            });

            // 如果没找到 checked 的选项，尝试从 select 或其他方式获取
            if (!foundMatch) {
                // 尝试查找 select[name="id"]（某些主题使用下拉框）
                const masterSelector = this.productForm.querySelector('select[name="id"]');
                if (masterSelector && masterSelector.options && masterSelector.selectedIndex >= 0) {
                    const selectedVariant = masterSelector.options[masterSelector.selectedIndex];
                    if (selectedVariant) {
                        const variantTitle = selectedVariant.textContent;
                        inputs.forEach((input) => {
                            if (variantTitle.includes(input.value)) {
                                this.selectedSize = input.value;
                                input.checked = true;
                                foundMatch = true;
                            }
                        });
                    }
                }
            }

            // 如果还是没找到匹配，使用第一个非自定义尺寸
            if (!foundMatch) {
                for (let input of inputs) {
                    if (!this.isCustomSize(input.value)) {
                        this.selectedSize = input.value;
                        input.checked = true;
                        break;
                    }
                }
            }

            // 延迟高亮以确保DOM完全加载，使用较长延迟确保表格渲染完成
            this.$nextTick(() => {
                // 使用 requestAnimationFrame 确保 DOM 完全渲染后再执行高亮
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        this.highlightSizeInChart(this.selectedSize, true);
                    }, 150);
                });
            });
        },

        // 处理尺寸变更
        handleSizeChange(value, optionPosition) {
            this.selectedSize = value;

            if (this.productForm) {
                this.updateOriginalSelector(optionPosition, value);
                this.triggerVariantUpdate();
            }

            this.$nextTick(() => {
                this.highlightSizeInChart(value, false);
            });
        },

        // 更新原始选择器
        updateOriginalSelector(optionPosition, selectedValue) {
            if (!this.productForm) return;

            // 更新隐藏的select元素
            const originalSelect = this.productForm.querySelector(`select[name="option${optionPosition}"]`);
            if (originalSelect) {
                originalSelect.value = selectedValue;
            }

            // 更新主变体选择器
            const masterSelector = this.productForm.querySelector('select[name="id"]');
            if (masterSelector) {
                const variants = Array.from(masterSelector.options);
                const selectedVariant = variants.find((option) => option.textContent.includes(selectedValue));
                if (selectedVariant) {
                    masterSelector.value = selectedVariant.value;
                }
            }
        },

        // 触发变体更新
        triggerVariantUpdate() {
            if (!this.productForm) return;

            const masterSelector = this.productForm.querySelector('select[name="id"]');
            if (masterSelector) {
                masterSelector.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // 如果有product-variants组件，触发其更新
            const productVariants = this.productForm.closest('product-variants');
            if (productVariants && typeof productVariants.updateVariant === 'function') {
                productVariants.updateVariant();
            }
        },

        // 切换主区域单位
        setUnit(newUnit) {
            this.unit = newUnit;
            this.$nextTick(() => {
                this.highlightSizeInChart(this.selectedSize, false);
            });
        },

        // 切换弹窗单位
        setPopupUnit(newUnit) {
            this.popupUnit = newUnit;
        },

        // 切换移动端弹窗单位
        setPopupMobileUnit(newUnit) {
            this.popupMobileUnit = newUnit;
        },

        // 打开弹窗
        openPopup() {
            const popupDrawer = document.getElementById('custom-size-pop-up');
            const popupMobile = document.getElementById('custom-size-pop-up-mobile');

            if (window.innerWidth >= 768) {
                // 桌面端打开 drawer
                if (popupDrawer) {
                    popupDrawer.open = true;
                }
            } else {
                // 移动端打开 popover
                if (popupMobile) {
                    popupMobile.open = true;
                }
            }
        },

        // 检查是否为自定义尺寸
        isCustomSize(size) {
            if (!size) return false;
            const customKeywords = ['custom', 'customize', 'customized', 'personalized', 'made to order'];
            const sizeLower = size.toLowerCase();
            return customKeywords.some((keyword) => sizeLower.includes(keyword));
        },

        // 判断尺寸行是否应该高亮
        isSizeHighlighted(rowSize) {
            if (!this.selectedSize || this.isCustomSize(this.selectedSize)) return false;
            const sizesToHighlight = this.parseSizeForHighlight(this.selectedSize);
            return sizesToHighlight.includes(rowSize);
        },

        // 解析尺寸用于高亮
        parseSizeForHighlight(selectedSize) {
            const sizes = [];

            // 处理年龄范围格式，如 "4-5 Years(120cm)" 或 "4-5岁"
            const ageRangeMatch = selectedSize.match(/(\d+)-(\d+)/);
            if (ageRangeMatch) {
                sizes.push(ageRangeMatch[1], ageRangeMatch[2]);
                return sizes;
            }

            // 处理带"y"后缀的年龄格式，如 "6y", "7y", "8y", "10y", "12y", "14y"
            const yearSuffixMatch = selectedSize.match(/^(\d+)y$/i);
            if (yearSuffixMatch) {
                sizes.push(yearSuffixMatch[1]);
                return sizes;
            }

            // 处理带"T"后缀的年龄格式，如 "2T", "3T", "4T", "5T"
            const tSuffixMatch = selectedSize.match(/^(\d+)T$/i);
            if (tSuffixMatch) {
                sizes.push(tSuffixMatch[1]);
                return sizes;
            }

            // 处理单个年龄，如 "4 Years" 或 "4岁"
            const singleAgeMatch = selectedSize.match(/^(\d+)$/);
            if (singleAgeMatch) {
                sizes.push(singleAgeMatch[1]);
                return sizes;
            }

            // 处理标准尺寸格式，如 "S", "M", "L" 等
            const standardSizeMatch = selectedSize.match(/^([A-Z]+|\d+[A-Z]*)$/);
            if (standardSizeMatch) {
                sizes.push(selectedSize);
                return sizes;
            }

            return sizes;
        },

        // 高亮尺寸表中的对应行
        // isInitial: 是否为页面初始化时的高亮（需要额外处理确保动画生效）
        highlightSizeInChart(selectedSize, isInitial = false) {
            if (!selectedSize || this.isCustomSize(selectedSize)) return;

            const sizesToHighlight = this.parseSizeForHighlight(selectedSize);
            if (sizesToHighlight.length === 0) return;

            // 查找第一个高亮行并滚动
            this.$nextTick(() => {
                // 使用 $refs 获取当前显示的尺寸表
                const activeChart = this.unit === 'inches' ? this.$refs.sizeChartInches : this.$refs.sizeChartCm;
                if (!activeChart) return;

                const firstRow = activeChart.querySelector(`tr[data-size="${sizesToHighlight[0]}"]`);
                if (firstRow) {
                    this.scrollToSizeRow(activeChart, firstRow, isInitial);
                }

                // 初始化时，也高亮所有匹配的行
                if (isInitial && sizesToHighlight.length > 1) {
                    sizesToHighlight.forEach((size) => {
                        const row = activeChart.querySelector(`tr[data-size="${size}"]`);
                        if (row && row !== firstRow) {
                            this.applyHighlightAnimation(row);
                        }
                    });
                }
            });
        },

        // 应用高亮动画到指定行
        applyHighlightAnimation(row) {
            if (!row) return;
            row.style.animation = 'none';
            row.offsetHeight; // 触发重排
            row.style.animation = 'sizeHighlightPulse 1s ease-in-out';
            setTimeout(() => {
                row.style.animation = '';
            }, 1000);
        },

        // 滚动到指定行
        // isInitial: 是否为页面初始化时的滚动
        scrollToSizeRow(chart, row, isInitial = false) {
            if (!chart || !row) return;

            // 初始化时使用较长延迟，确保表格完全渲染
            const delay = isInitial ? 200 : 100;

            setTimeout(() => {
                const rowTop = row.offsetTop;
                const chartHeight = chart.clientHeight;
                const rowHeight = row.offsetHeight;

                const targetScrollTop = rowTop - chartHeight / 2 + rowHeight / 2;
                const maxScrollTop = chart.scrollHeight - chartHeight;
                const finalScrollTop = Math.max(0, Math.min(targetScrollTop, maxScrollTop));

                chart.scrollTo({
                    top: finalScrollTop,
                    behavior: 'smooth',
                });

                // 添加闪烁动画
                this.applyHighlightAnimation(row);
            }, delay);
        },

        // 计算预计送达日期
        calculateDeliveryDate() {
            try {
                const today = new Date();

                // 生产时间：10-15天
                const productionMinDays = 10;
                const productionMaxDays = 15;

                // 运输时间：5-10天
                const shippingMinDays = 5;
                const shippingMaxDays = 10;

                const earliestDelivery = new Date(today);
                earliestDelivery.setDate(today.getDate() + productionMinDays + shippingMinDays);

                const latestDelivery = new Date(today);
                latestDelivery.setDate(today.getDate() + productionMaxDays + shippingMaxDays);

                const formatDate = (date) => {
                    const months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
                    return `${months[date.getMonth()]} ${date.getDate()}`;
                };

                this.deliveryDateRange = `${formatDate(earliestDelivery)} - ${formatDate(latestDelivery)}`;
            } catch (error) {
                console.error('Error calculating delivery date:', error);
                this.deliveryDateRange = '计算错误';
            }
        },
    }));
});